import { getReq } from '../../utils/request'
import { IDashboardRatings } from '../../reducers/ratings/actions'

const fetchDashboardRatings = async () => {
	const { data } = await getReq('/api/admin/dashboard/ratings')

	return data as IDashboardRatings
}

export default fetchDashboardRatings
